import React, { useState, useEffect } from "react";
import { Button, Form, Row, Modal } from "react-bootstrap";
import { CForm, CCol, CFormLabel, CFormFeedback, CFormInput, CButton } from "@coreui/react";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import { toastMessage } from "../../../helpers/utility.js";
import { getData, modifyData } from "../../../redux/slices/MasterSupplierSlice";
// import DeleteConfirmationModal from "../../../pagecomponents/Common/DeleteConfirmationModal";
import PageWrapper from "../../../pagecomponents/Common/PageWrapper";
import DataTable from "../../../pagecomponents/Common/DataTable";
import Swal from "sweetalert2";



const INIT_FORM_DATA = {
    supplier_Name : "",
    supplier_Mobile : "",
    supplier_Email : "",
    supplier_address_Line_1 : "",
    supplier_address_Line_2 : "",
    supplier_address_City : "",
    supplier_address_State : "",
    supplier_address_Country : "",
    supplier_address_Postcode : "",
    client_Id: 1,
    ledger_Opening_Balance: '',
    ledger_type: ''
};

const SupplierIndex = () => {
    const dispatch = useDispatch();
    const pageName = "Supplier";
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalPage, setTotalPage] = useState(0);

    const PARAMS = {
        skip: 0,
        take: rowsPerPage,
        searchStr: "",
        sorting: 'asc',
        sorting_key: 'created_at',
        filter: {
            
        }
    };

    const [data, setData] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [params, setParams] = useState(PARAMS);
    const [formData, setFormData] = useState(INIT_FORM_DATA);
    const [validated, setValidated] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    // const [deleteAlertVisible, setDeleteAlertVisible] = useState(false);
    // const [isDelete, setIsDelete] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaveDisabled, setIsSaveDisabled] = useState(false);

    useEffect(()=> {
        fetchMasterData();
    }, [params]);

    // API calls

    const fetchMasterData = async () => {
        setIsLoading(true);
                
        try {
            const { payload } = await dispatch(getData({ inputData: params }));
            setData(payload.data);
            setTotalPage(Math.ceil(payload.count/rowsPerPage));
        } catch (err) {
            toastMessage("error", "Failed to fetch data");
        } finally {
            setIsLoading(false); // Stop loader
        }
    };

    const handleSave = async (formData) => {
        setIsSaveDisabled(true);
        const { payload } = await dispatch(modifyData({ inputData: formData }));
        if (payload?.status === "error") {
            setIsSaveDisabled(false);
            toastMessage("error", payload.msg || "An error occurred while saving.");
        } else {
            // toastMessage(payload?.status || "success", payload?.msg || "Operation successful.");

            if(formData.type === 'delete') {
                setIsSaveDisabled(false);
                // setDeleteAlertVisible(false);
                Swal.fire("Deleted!", "Your file has been deleted.", "success");
            } else {
                setIsSaveDisabled(false);
                toastMessage(payload?.status || "success", payload?.msg || "Operation successful.");
                closeModal();
            }

            fetchMasterData();

            // if(isDelete){
            //     setDeleteAlertVisible(false);
            // }
        }
    };


    // Event handlers

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        if(name === "supplier_Mobile"){
            if (/^\d*$/.test(value)) {
                // setMobile(value);
                setFormData({...formData, [name] : value});
            }
        } else {
            setFormData({...formData, [name] : value});
        }
    };

    const openAddModal = () => {
        setIsEdit(false);
        // setIsDelete(false);
        setModalVisible(true);
        setFormData(INIT_FORM_DATA);
    };

    const openEditModal = (item) => {
        setIsEdit(true);
        // setIsDelete(false);
        setFormData({...item, type: item.type || ''});
        setModalVisible(true);
    };

    const handleDelete = (item) => {
        // setFormData({...item, type: item.type || 'delete'});
        // setDeleteAlertVisible(true);
        // setIsDelete(true);
        const updatedFormData = { ...item, type: item.type || 'delete' };
        handleSave(updatedFormData);
    };
    
    const closeModal = () => {
        setModalVisible(false);
        setValidated(false);
        setFormData(INIT_FORM_DATA);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        } else {
            handleSave(formData);
        }
        setValidated(true);
    };

    // const handleSort = (key) => {
    //     setParams((prev) => ({
    //         ...prev,
    //         skip: 0,
    //         sorting: prev.sorting_key === key && prev.sorting === "asc" ? "desc" : "asc",
    //         sorting_key: key,
    //     }));
    // };

    const handleSort = (key) => {
        setCurrentPage(1);
        
        setParams((prev) => ({
            ...prev,
            skip: 0,
            sorting_key: key,
            sorting: prev.sorting_key === key && prev.sorting === "asc" ? "desc" : "asc",
        }));
    };

    const handleRowsPerPageChange = (rows) => {
        setRowsPerPage(rows);
        setCurrentPage(1);
        
        setParams((prev) => ({
          ...prev,
          take: rows,
          skip: 0,
        }));
    };

    const setPage = (pagenum) => {
        setCurrentPage(pagenum);
        setParams((prev) => ({
            ...prev,
            skip: (pagenum - 1) * prev.take,
        }));
    };

    const columns = [
        {label: "#", accessor: "index", sortable: false},
        {label: "Name", accessor: "supplier_Name", sortable: true},
        {label: "Phone No", accessor: "supplier_Mobile", sortable: true},
        {label: "Email", accessor: "supplier_Email", sortable: true},
        {label: "Op Balance", accessor: "ledger_Opening_Balance", sortable: true},
        {label: "Type", accessor: "ledger_type", sortable: false},
    ];

    return(
        <>
            <ToastContainer />
            <PageWrapper 
                pageName={pageName}
                headerBtnTitle="+ Supplier"
                onHeaderButtonClick={() => {openAddModal()}}
                showAddBtn={true}
            >
                <DataTable 
                    columns={columns} 
                    data={data} 
                    onEdit={openEditModal}
                    onDelete={handleDelete}
                    onSorting={handleSort}
                    sortingState={{ key: params.sorting_key, order: params.sorting }}
                    currentPage={currentPage}
                    totalPages={totalPage}
                    rowsPerPage={rowsPerPage}
                    updateRowsPerPage={handleRowsPerPageChange}
                    onPageChange={setPage}
                    loader={isLoading}
                />
            </PageWrapper>
            
            {/* Add/Edit Modal */}
            <Modal size="lg" show={modalVisible}>
                <Modal.Header className="bg-dark text-white">
                    <Modal.Title>{isEdit ? 'Edit' : 'Add'} Supplier</Modal.Title>
                    <Button variant="close" className="btn btn-close text-white" onClick={closeModal} aria-label="Close">x</Button>
                </Modal.Header>
                <Modal.Body>
                    <CForm
                    className="g-3 needs-validation"
                    noValidate
                    validated={validated}
                    onSubmit={handleSubmit}
                    >
                        <Row className="row-xs mb-2">
                            <CCol md={12}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="name">Supplier Name</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="supplier_Name"
                                    name="supplier_Name"
                                    value={formData.supplier_Name}
                                    onChange={handleInputChange}
                                    required
                                />
                                <CFormFeedback invalid>Enter Supplier Name</CFormFeedback>
                            </CCol>
                        </Row>
                        <Row className="row-xs mb-2">
                            <CCol md={6}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="mobile">Mobile</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="supplier_Mobile"
                                    name="supplier_Mobile"
                                    value={formData.supplier_Mobile}
                                    onChange={handleInputChange}
                                    // required
                                />
                                <CFormFeedback invalid>Enter mobile number</CFormFeedback>
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="email">Email</CFormLabel>
                                <CFormInput
                                    type="email"
                                    id="supplier_Email"
                                    name="supplier_Email"
                                    value={formData.supplier_Email}
                                    onChange={handleInputChange}
                                    // required
                                    // pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                                />
                                {/* <CFormFeedback invalid>Enter a valid email address</CFormFeedback> */}
                            </CCol>
                        </Row>
                        <Row className="row-xs mb-2">
                            <CCol md={3}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="address1">House No</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="supplier_address_Line_1"
                                    name="supplier_address_Line_1"
                                    value={formData.supplier_address_Line_1}
                                    onChange={handleInputChange}
                                />
                            </CCol>
                            <CCol md={9}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="address2">Street Name</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="supplier_address_Line_2"
                                    name="supplier_address_Line_2"
                                    value={formData.supplier_address_Line_2}
                                    onChange={handleInputChange}
                                />
                            </CCol>
                        </Row>
                        <Row className="row-xs mb-2">
                            <CCol md={6}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="address1">City</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="supplier_address_City"
                                    name="supplier_address_City"
                                    value={formData.supplier_address_City}
                                    onChange={handleInputChange}
                                />
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="address2">State</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="supplier_address_State"
                                    name="supplier_address_State"
                                    value={formData.supplier_address_State}
                                    onChange={handleInputChange}
                                />
                            </CCol>
                        </Row>
                        <Row className="row-xs mb-2">
                            <CCol md={6}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="address1">Country</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="supplier_address_Country"
                                    name="supplier_address_Country"
                                    value={formData.supplier_address_Country}
                                    onChange={handleInputChange}
                                />
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="address2">Postcode</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="supplier_address_Postcode"
                                    name="supplier_address_Postcode"
                                    value={formData.supplier_address_Postcode}
                                    onChange={handleInputChange}
                                />
                            </CCol>
                        </Row>
                        <Row className="row-xs mb-2">
                            <CCol md={9}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="ledger_Opening_Balance">Opening Balance</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="ledger_Opening_Balance"
                                    name="ledger_Opening_Balance"
                                    value={formData.ledger_Opening_Balance}
                                    onChange={handleInputChange}
                                />
                            </CCol>
                            <CCol md={3}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="ledger_type">Type</CFormLabel>
                                <Form.Select
                                    className="form-control"
                                    id="ledger_type"
                                    name="ledger_type"
                                    value={formData.ledger_type}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Select</option>
                                    <option value="Dr">Dr</option>
                                    <option value="Cr">Cr</option>
                                </Form.Select>
                            </CCol>
                        </Row>
                        <Row className="row-xs mb-2 btn-animation">
                            <CCol xs={12} className="mt-10">
                                <CButton 
                                color="primary" 
                                className={`btn btn-sm float-end ${isSaveDisabled ? 'btn-loaders' : ''}`}
                                type="submit"
                                disabled={isSaveDisabled}
                                >
                                    {isSaveDisabled ? (<span className="loading">Save Changes</span>) : 'Save Changes'}
                                </CButton>
                                <CButton color="secondary" className="btn btn-sm float-end me-2" onClick={closeModal} disabled={isSaveDisabled}>Close</CButton>
                            </CCol>
                        </Row>
                    </CForm>
                </Modal.Body>
            </Modal>

            {/* Delete Alert Modal */}
            {/* <DeleteConfirmationModal 
                show={deleteAlertVisible}
                onHide={() => setDeleteAlertVisible(false)}
                onConfirm={handleSave}
                message={'Are you sure you want to delete this record? This action is irreversible.'}
            /> */}
        </>
    );
};

export default SupplierIndex;